/**
 * Public routes
 */
export const HOME = '/'
export const ABOUT_US = '/about-us'
export const EXPLORE = '/explore'
export const PROJECT = '/project'
export const NEWS = '/news'
export const FAQ = '/faq'
export const CONTACT = '/contact'
export const JOIN = `/join`
export const PRIVACY_POLICY = '/privacy-policy'
export const COMMUNITY_GUIDELINES = '/community-guidelines'

export const LOGIN = '/login'
export const VERIFY_TOKEN = '/verify'
export const RESET_PASSWORD = '/reset-password'
export const RESET_PASSWORD_CONFIRMATION = '/reset-password-confirmation'
export const RESET_PASSWORD_VERIFY = '/reset-password-verify'

/**
 * Private routes
 */
export const PRIVATE_HOME = '/app'
export const PRIVATE_MAP = '/app/map'
export const PRIVATE_CALENDAR = '/app/calendar'
export const PRIVATE_PROFILE = '/app/profile'
export const PRIVATE_REQUESTS = '/app/requests'
export const PRIVATE_REQUESTS_FRIENDS = '/app/requests/connected'
export const PRIVATE_REQUESTS_GROUPS = '/app/requests/groups'
export const PRIVATE_CHAT = '/app/chat'
export const PRIVATE_CONNECTIONS = '/app/connections'
export const PRIVATE_CONNECTIONS_FRIENDS = '/app/connections/connected'
export const PRIVATE_CONNECTIONS_GROUPS = '/app/connections/groups'
export const PRIVATE_CONNECTIONS_MATCHED = '/app/connections/matched'
export const PRIVATE_CONNECTIONS_OTHERS = '/app/connections/others'
/** @deprecated Use PRIVATE_CONNECTIONS instead */
export const PRIVATE_FRIENDS = PRIVATE_CONNECTIONS
export const PRIVATE_SETTINGS = '/app/settings'
